module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiCnIt.06ad6f1.eot";